// extracted by mini-css-extract-plugin
export var heading = "industry-grid-module--heading--TkY2S";
export var industryGrid = "industry-grid-module--industryGrid--Ebq6f";
export var industryGridItem = "industry-grid-module--industryGridItem--+3Q3F";